import { IssueType } from "solar-bo";
import { IssueTypeHelper } from "../models/IssueTypeHelper.model";


export class DashBoardHelper {

  /**
   * Color for issue type chart
   * @param issueType 
   */
  public static chartIssueColor(issueType) {
    return IssueTypeHelper.issueGetErrorTypeColor(issueType);
  }
  /**
   * Return an string designed for charts
   * @param issueType 
   */
  public static chartIssueDescription(issueType) {
    let res = "";
    const st = issueType;
    if (st === IssueType.PCS) {
      //multipleh hot spot
      res = "N Hot spots";
    } else if (st === IssueType.CCS) {
      //several hot cells
      res = "N Hot cells";
    } else {
      res = IssueTypeHelper.issueGetErrorTypeDescription(issueType);
    }

    return res;
  }

  public static chartGetRandomColor() {
    let letters = '0123456789ABCDEF'.split('');
    let color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
}